import React from 'react';
import BuildingMarker from 'components/views/BuildingMarker';
import {getState} from 'utils/buildings';
import * as buildingDicts from 'dicts/buildings';
import {FormattedMessage} from '@meiko/react-intl';
import {twMerge} from 'tailwind-merge';

const BuildingEncounterStateTag = ({
	building,
	activeOrganization,
	preferD2DState = false,
	className = '',
}) => {
	return (
		<div className={twMerge('flex items-center gap-x-2', className)}>
			<BuildingMarker state={getState(building, activeOrganization, preferD2DState)} />
			<span className="truncate">
				<FormattedMessage
					id={
						// note: consciously using the encounter state as opposed to the full building state here. the marker displays the full building state already, but the concrete encounter state may be of interest too.
						preferD2DState && building.encounterD2DState
							? buildingDicts.encounterStateAll[building.encounterD2DState]
							: buildingDicts.encounterStateNoD2d[building.encounterState]
					}
				/>
			</span>
		</div>
	);
};

export default BuildingEncounterStateTag;
